import { useEffect, useRef, useState } from 'react';
import { Check2, Clipboard } from 'react-bootstrap-icons';

interface CopyButtonProps {
  /** The text put on the clipboard. */
  value: string;
  /** What the value is, for the tooltip and the screen reader: "Copy digest". */
  label: string;
  size?: number;
}

/** A small icon button that copies a value and confirms it with a tick. */
export function CopyButton({ value, label, size = 13 }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => () => void (timer.current && clearTimeout(timer.current)), []);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      console.error('Copy failed', e);
    }
  };

  return (
    <button
      type="button"
      className="copy-button"
      onClick={copy}
      title={copied ? 'Copied' : label}
      aria-label={copied ? 'Copied' : label}
    >
      {copied ? <Check2 size={size} /> : <Clipboard size={size} />}
    </button>
  );
}

export default CopyButton;
